import { render, staticRenderFns } from "./IfElseQuestion.vue?vue&type=template&id=5044212f&scoped=true"
import script from "./IfElseQuestion.vue?vue&type=script&lang=js"
export * from "./IfElseQuestion.vue?vue&type=script&lang=js"
import style0 from "./IfElseQuestion.vue?vue&type=style&index=0&id=5044212f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5044212f",
  null
  
)

export default component.exports